module.exports = __webpack_public_path__ + "static/media/1.fe865078.png";